"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var constants_1 = require("../constants");
var icons_1 = require("../../../../common/icons");
var image_1 = require("../../../../common/image");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return ({
        root: {
            boxShadow: theme.shadows[2],
            background: theme.palette.common.white,
        },
        labelSection: {
            borderRight: theme.youwell.borders.dim,
            textAlign: 'right',
            fontWeight: 500,
            minWidth: 200,
        },
        valueSection: (_a = {
                textAlign: 'center',
                minWidth: 200
            },
            _a[theme.breakpoints.down('xs')] = {
                minWidth: 100,
            },
            _a),
        labelWrapper: {
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
        },
        sleepEfficiency: {
            borderRadius: theme.youwell.shapes.borderRadiusFlatter,
            color: theme.palette.common.white,
            padding: theme.spacing(2, 4),
        },
        goodSleep: {
            backgroundColor: theme.palette.secondary.main,
        },
        badSleep: {
            backgroundColor: theme.palette.error.main,
        },
        divider: {
            borderBottom: theme.youwell.borders.normal,
        },
        icons: {
            marginLeft: theme.spacing(2),
            verticalAlign: 'middle',
        },
    });
}, { name: 'DaySummaryTable' });
var DaySummaryTable = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var day = _a.day;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var sleepEfficiency = (day.totalSleepMinutes && day.totalBedMinutes) ? Number(((day.totalSleepMinutes / day.totalBedMinutes)) * 100).toFixed(0) : 0;
    return (React.createElement(core_1.Table, { className: classes.root },
        React.createElement(core_1.TableBody, null,
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.sleepQuality')),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.totalSleepMinutes && day.totalBedMinutes ? (React.createElement("span", { className: (0, classnames_1.default)(classes.sleepEfficiency, sleepEfficiency < 70 ? classes.badSleep : classes.goodSleep) }, "".concat(sleepEfficiency, "%"))) : translate('sleepDiary.registrationMissing'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.totalSleepMinutes')),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.totalSleepMinutes ? ((0, dateUtils_1.hourCount)(day.totalSleepMinutes, translate)) : translate('sleepDiary.registrationMissing'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                    React.createElement("div", { className: classes.labelWrapper },
                        translate('sleepDiary.totalBedMinutes'),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(icons_1.SleepIcon, { className: classes.icons })))),
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, day.totalBedMinutes ? (0, dateUtils_1.hourCount)(day.totalBedMinutes, translate) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.dayView.daytimeActivityRatings')),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, constants_1.daytimeActivityRatings.find(function (d) { return d.id === day.daytimeActivityRating; }) ? (translate("".concat((_b = constants_1.daytimeActivityRatings.find(function (d) { return d.id === day.daytimeActivityRating; })) === null || _b === void 0 ? void 0 : _b.label))) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.dayTimeNaps')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.SleepSmileyIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.daytimeNaps && day.daytimeNaps.length > 0 ? day.daytimeNaps.map(function (nap) {
                    var _a;
                    return (React.createElement("div", { key: (_a = nap.sleepTime) === null || _a === void 0 ? void 0 : _a.toString() }, nap.wakeTime && nap.sleepTime
                        ? (React.createElement(React.Fragment, null,
                            React.createElement("span", null, "".concat((0, dateUtils_1.hourCount)((0, dateUtils_1.getNumberOfMinutes)(nap.sleepTime, nap.wakeTime), translate), " ")),
                            React.createElement("span", null, "".concat(translate('sleepDiary.dayView.at'), " ").concat((0, dateUtils_1.getTimePartForInput)(nap.sleepTime))))) : (React.createElement("span", null, " - ".concat(translate('sleepDiary.dayView.at'), " ").concat((0, dateUtils_1.getTimePartForInput)(nap.sleepTime))))));
                }) : ((_c = day.sleepProperties) === null || _c === void 0 ? void 0 : _c.hasDaytimeNaps) === false ? translate('sleepDiary.none') : translate('sleepDiary.registrationMissing'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null,
                            React.createElement("div", null, translate('sleepDiary.dayView.sleepMedication')),
                            React.createElement("div", null, translate('sleepDiary.dayView.alcohol'))),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.MedicineIcon, null)))),
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, ((_d = day.sleepProperties) === null || _d === void 0 ? void 0 : _d.sleepMedication) ? (day.sleepProperties.sleepMedication) : translate('sleepDiary.none'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.gotToBed')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.MoonIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.bedTime ? (0, dateUtils_1.getTimePartForInput)(day.bedTime) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.tiredToSleep')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.SleepSmileyIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.sleepAtemptTime ? (0, dateUtils_1.getTimePartForInput)(day.sleepAtemptTime) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.fellAsleep')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.SleepSmileyIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.sleepTime ? (0, dateUtils_1.getTimePartForInput)(day.sleepTime) : translate('sleepDiary.registrationMissing'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.awake')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.AwakeSmileyIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, ((_e = day.sleepProperties) === null || _e === void 0 ? void 0 : _e.numberOfNightWakeups) ? ("".concat((_f = day.sleepProperties) === null || _f === void 0 ? void 0 : _f.numberOfNightWakeups, " ").concat(translate('sleepDiary.dayView.times'))) : ((_g = day.sleepProperties) === null || _g === void 0 ? void 0 : _g.numberOfNightWakeups) === 0 ? '-' : translate('sleepDiary.registrationMissing'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.nightWakeupsTotalMinutes')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.AwakeSmileyIcon, null)))),
                React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, ((_h = day.sleepProperties) === null || _h === void 0 ? void 0 : _h.nightWakeupsTotalMinutes) ? ("".concat(day.sleepProperties.nightWakeupsTotalMinutes, " ").concat(translate('sleepDiary.dayView.min'))) : ('-'))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.youWokeUp')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(icons_1.SunIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.wakeTime ? ((0, dateUtils_1.getTimePartForInput)(day.wakeTime)) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { align: "center", className: classes.labelSection },
                    React.createElement("div", { className: classes.labelWrapper },
                        React.createElement("div", null, translate('sleepDiary.dayView.youGotOutOfBed')),
                        React.createElement("span", { className: classes.icons },
                            React.createElement(image_1.WakeUpIcon, null)))),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.outOfBedTime ? ((0, dateUtils_1.getTimePartForInput)(day.outOfBedTime)) : (translate('sleepDiary.registrationMissing')))),
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.yourSleepRating')),
                React.createElement(core_1.TableCell, { className: classes.valueSection }, day.sleepRating ? (translate(((_j = constants_1.sleepRatings.find(function (d) { return day.sleepRating === d.id; })) === null || _j === void 0 ? void 0 : _j.label) || '', undefined, { onMissingTranslation: function () { var _a; return ((_a = day.sleepRating) === null || _a === void 0 ? void 0 : _a.toString()) || ''; } })) : (translate('sleepDiary.registrationMissing')))))));
};
exports.default = DaySummaryTable;
